<template>
  <div>
    <div class="card mb-3">
      <div class="card-header">登録情報の編集</div>
      <div class="card-body">
        <div class="mt-2">
          <p>
            ご住所・お電話番号等の変更の際にはスタッフまでお電話ください。
          </p>

          <div v-if="Object.keys(errors).length" class="alert alert-danger d-none">
            <ul>
              <template v-for="(value) in Object.values(errors).flat()">
                <li>{{ value }}</li>
              </template>
            </ul>
          </div>

          <form @submit.prevent="update">
            <dl class="row">
              <dt class="col-md-2">パスワード</dt>
              <dd class="col-md-10">
                <input type="text" name="password" v-model="member['password']" class="form-control" pattern="[\x20-\x7E]*" minlength="8" placeholder="変更する場合のみ入力してください">
                <span v-for="error in errors.password" class=" invalid-feedback d-block">{{ error }}</span>
              </dd>

              <dt class="col-md-2">メールアドレス</dt>
              <dd class="col-md-10">
                <input type="text" name="email" v-model="member['email']" :required="member['plan_id'] !== 1" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" class="form-control">
                <span v-for="error in errors['email']" class=" invalid-feedback d-block">{{ error }}</span>
              </dd>

              <dt class="col-md-2"></dt>
              <dd class="col-md-10">
                <button dusk="profile_update" type="submit" name="submit" class="btn btn-success">保存する</button>
              </dd>
            </dl>
          </form>
        </div>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header">プロフィール画像の編集</div>

      <div class="card-body">
        <dl class="row form-group">
          <dt class="col-md-2">プロフィール画像</dt>
          <dd class="col-md-10">
            <div class="input-group">
              <div class="input-group-prepend">
                <button dusk="profile_file_upload" type="button" @click="fileUpload" class="btn btn-success">設定する</button>
              </div>
              <div class="custom-file">
                <input type="file" id="inputGroupFile" name="file" @change="onFileChange" class="custom-file-input">
                <label class="custom-file-label" for="inputGroupFile" data-browse="参照">{{ imageLabel || "ファイル選択..." }}</label>
              </div>
            </div>

            <div class="mt-3">
              <button dusk="profile_file_delete" type="button" @click="fileDelete" class="btn btn-danger">削除する</button>
            </div>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      id: this.$route.params.id,
      member: {},
      genders: {
        male: '男性',
        female: '女性'
      },
      imageLabel: null,
      uploadFile: null,
      errors: {},
    }
  },
  async created() {
    this.$store.commit("loading/setLoading", true);

    // 戻りリンク先を設定
    this.$store.commit("backButton/setTo", "/member/profile");

    await axios.get('/member/api/profile/')
        .then(response => this.member = response.data.member)
        .catch(error => this.$store.state.error.code = error.response.status);

    this.$store.commit("loading/setLoading", false);
  },
  methods: {
    onFileChange(e) {
      // ファイル名を表示
      let files = e.target.files || e.dataTransfer.files;
      this.imageLabel = files[0]['name'];

      // ファイルを保存
      this.uploadFile = files[0];
    },
    async fileUpload() {
      // ファイルが指定されていなければスキップ
      if (!this.uploadFile) {
        return;
      }

      // フォームオブジェクトを生成
      let formData = new FormData();
      formData.append('image', this.uploadFile);

      this.$store.commit("loading/setLoading", true);

      // ファイルをアップロード
      await axios.post('/member/api/profile/image', formData, {
        headers: {
          'content-type': 'multipart/form-data',
          'X-HTTP-Method-Override': 'PUT'
        }
      })
          .then(response => {
                this.imageLabel = null;
                this.uploadFile = null;
                this.$toasted.show('保存しました');
              }
          )
          .catch(error => {
            this.$store.state.error.code = error.response.status
          });

      this.$store.commit("loading/setLoading", false);
    },
    fileDelete() {
      // ファイルを削除
      this.$dialog.confirm("ファイルを削除してよろしいですか?").then(() => {
        axios.delete('/member/api/profile/image')
            .then(response => {
                  this.imageLabel = null;
                  this.uploadFile = null;
                  this.$toasted.show('削除しました');
                }
            )
            .catch(error => this.$store.state.error.code = error.response.status)
      });
    },
    update() {
      axios.put('/member/api/profile', this.member)
          .then(response => {
                this.member.password = "";
                this.$toasted.show('保存しました');
                this.errors = {};
              }
          )
          .catch((
              (error) => {
                const {data, status, statusText} = error.response;
                if (status === 422) {
                  this.errors = data.errors;
                } else {
                  this.errors = {};
                  this.$store.state.error.code = error.response.status;
                }
              }
          ));
    }
  },
}
</script>
